import { render, staticRenderFns } from "./nearby.vue?vue&type=template&id=bff349d6&scoped=true&"
import script from "./nearby.vue?vue&type=script&lang=js&"
export * from "./nearby.vue?vue&type=script&lang=js&"
import style0 from "./nearby.vue?vue&type=style&index=0&id=bff349d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff349d6",
  null
  
)

export default component.exports